// extracted by mini-css-extract-plugin
module.exports = {"width-160":"_111OqutEkf","width-430":"_3i7bxSc4ry","remark":"_1DaRur9eCB","reminder-block":"z-R3edJ4Pi","text-button":"_2rjxlVHiO2"};